/**
 * News Listing Vue App
 */

import { createApp } from 'vue';
import NewsListing from './components/NewsListing.vue';

document.addEventListener('DOMContentLoaded', () => {
	const container = document.getElementById('news-listing-app');

	if (!container) {
		return;
	}

	const app = createApp(NewsListing);

	app.config.globalProperties.$wordpress = {
		ajaxUrl: window.jaeckleData?.ajaxUrl || '/wp-admin/admin-ajax.php',
		nonce: window.jaeckleData?.nonce || '',
	};

	app.mount('#news-listing-app');
});
